// 「点遮罩关闭」的正确做法：只有**按下**和**松开**都落在遮罩本身时才关。
//
// 为什么不能直接用 @click.self：在弹框里按住鼠标选文字、拖到遮罩上松手时，
// 浏览器把 click 事件派发到 mousedown/mouseup 两个目标的共同祖先 —— 也就是遮罩，
// 于是「选中一段文字拖出去」会被当成「点了遮罩」，弹框突然关掉。
//
// 用法：const backdrop = backdropClose(() => props.closeOnBackdrop, () => emit("close"));
//      模板：<div class="ro-overlay" v-on="backdrop">
export function backdropClose(isEnabled: () => boolean, close: () => void) {
  let startedOnBackdrop = false;
  return {
    pointerdown(event: PointerEvent) {
      startedOnBackdrop = event.target === event.currentTarget;
    },
    pointerup(event: PointerEvent) {
      // 从遮罩按下去、拖进弹框里松手：也不算点遮罩
      if (event.target !== event.currentTarget) startedOnBackdrop = false;
    },
    click(event: MouseEvent) {
      const closeIt = startedOnBackdrop && event.target === event.currentTarget;
      startedOnBackdrop = false;
      if (closeIt && isEnabled()) close();
    }
  };
}
